import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';
import { Generator } from '../topic-widgets/generator';
import { knownClasses } from './table-util';
import css from '@holmescorp/book-widgets/css/topicpage.m.css';
const factory = create({ theme }).properties();
export const TableBodyRow = factory(({ properties, middleware: { theme } }) => {
    const { entries, rowAttrs = {}, firstchild, widths } = properties();
    const themeCss = theme.classes(css);
    const allEntries = [];
    let idx = 0;
    entries.forEach((item) => {
        const { attributes = {} } = item.entry;
        const { colname, nameend } = attributes;
        if (nameend !== undefined) {
            idx = +nameend;
        }
        else if (colname !== undefined) {
            idx = +colname;
        }
        else {
            idx += 1;
        }
        allEntries.push(item);
    });
    const cols = allEntries.map((item, idx) => {
        if (item === null) {
            const styles = firstchild ? { width: `${widths.get('col-1').width}rem` } : {};
            return v('td', { styles });
        }
        const { attributes = {}, children = [] } = item.entry;
        const { outputclass, namest = 1, nameend = 1, morerows = 0, colsep, colname = idx + 1, align } = attributes;
        const name = `col-${colname}`;
        const defaultColSep = widths.get(name).separator || null;
        const separator = colsep === undefined ? defaultColSep : colsep === 0 ? themeCss.noColumnSeparator : themeCss.columnSeparator;
        const colspan = namest !== nameend ? `${nameend - namest + 1}` : null;
        const rowspan = morerows > 0 ? `${morerows + 1}` : null;
        const styles = firstchild && colspan === null ? { width: `${widths.get(name).width}rem` } : {};
        const classes = outputclass && knownClasses.has(outputclass) ? [themeCss[outputclass]] : [];
        classes.push(separator);
        switch (align) {
            case 'left':
                classes.push(themeCss.alignLeft);
                break;
            case 'center':
                classes.push(themeCss.alignCenter);
                break;
            case 'right':
                classes.push(themeCss.alignRight);
                break;
        }
        return v('td', { classes, colspan, rowspan, styles }, [
            w(Generator, { topic: { attributes, children }, skipTitle: true, intable: true })
        ]);
    });
    const { rowsep } = rowAttrs;
    const defaultRowSep = widths.get('tgroup').separator || null;
    const separator = rowsep === undefined ? defaultRowSep : rowsep === 0 ? themeCss.noRowSeparator : themeCss.rowSeparator;
    const classes = [separator];
    return v('tr', { classes }, cols);
});
